// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"1ce62030","271":"d0dab2e7","460":"717eaf2d","639":"1ad1a07b"}[chunkId] + ".js";
};